export const statGridContainer = {
  mb: 1
};

export const statPaper = {
  mt: 1.5,
  borderRadius: 3,
  bgcolor: "#fafbff"
};

export const statTitle = {
  fontWeight: 700,
  mb: 2,
  color: "#3a3a3a"
};

export const statYearNote = {
  fontWeight: 400,
  color: "#888"
};